import { SendFormStep } from '../../types';
import { FormsSendingExperienceStoreState } from '../types';

export const INITIAL_STATE: FormsSendingExperienceStoreState = {
  formOrPacketToSend: undefined,
  solicitedLink: '',
  submissionToken: '',
  isCreatingTransientForm: false,
  currentStep: SendFormStep.SELECT_CONTACT,
  steps: [],
  isSending: false,
  isGeneratingSolicitedLink: false,
  personId: '',
  firstName: '',
  lastName: '',
  fullName: '',
  appointmentInfo: null,
  appointmentId: '',
  acceptedFiles: [],
  rejectedFiles: [],
  email: '',
  emailBody: '',
  emailSubject: 'Please complete these forms',
  showMessageComponent: true,
  isUploadInProgress: false,
  temporarilyHideModal: false,
  selectedDeliveryMethod: undefined,
  locationId: '',
  areFormsEnabledLocationIdsSet: false,
  formsEnabledLocationIds: [],
};
